// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"265":"4de8fedc","393":"4d24b8f5","404":"5e04e909","593":"15559057","800":"4fad388b","830":"c52a8a93","887":"3767ffc9","930":"6888cf38","955":"6e83c04b"}[chunkId] + ".js";
};